import type { TipoParceiro } from './produto'

export type { Parceiro, TipoParceiro } from './produto'

/** Espelha `dto/ParceiroRequest` (produtos). */
export interface ParceiroRequest {
  nome: string
  tipo: TipoParceiro
  cnpj: string
  contato?: string | null
  email: string
  telefone?: string | null
  produtosOferecidos?: string[]
}

/** Espelha `dto/ParceiroResumoResponse` — KPIs da página Parceiros. */
export interface ParceiroResumo {
  cadastrados: number
  ativos: number
  politicas: number
  politicasAtivas: number
  parceirosComPolitica: number
}

export const TIPOS_PARCEIRO: Record<TipoParceiro, string> = {
  BANCO: 'Banco',
  FUNDO: 'Fundo',
  FINTECH: 'Fintech',
  SECURITIZADORA: 'Securitizadora',
}
